import React from 'react';
import { Bell, Users, Award, Utensils, MapPin } from 'lucide-react';
import type { NotificationType } from '@/hooks/useNotifications';

export function getNotificationIcon(type: NotificationType) {
  switch (type) {
    case 'follower':
      return <Users className="h-4 w-4" />;
    case 'badge':
      return <Award className="h-4 w-4" />;
    case 'burger_suggestion':
      return <Utensils className="h-4 w-4" />;
    case 'place_suggestion':
      return <MapPin className="h-4 w-4" />;
    default:
      return <Bell className="h-4 w-4" />;
  }
}

export function getInitials(name: string | null | undefined, username?: string | null): string {
  if (name) {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  }
  if (username) {
    return username.slice(0, 2).toUpperCase();
  }
  return 'U';
}

export function NotificationSkeleton() {
  return (
    <div className="flex items-center gap-3 p-3 rounded-lg animate-pulse">
      <div className="w-12 h-12 bg-muted rounded-full" />
      <div className="flex-1 space-y-2">
        <div className="h-4 bg-muted rounded w-3/4" />
        <div className="h-3 bg-muted rounded w-1/2" />
      </div>
      <div className="h-8 bg-muted rounded w-20" />
    </div>
  );
}

export function EmptyNotifications() {
  return (
    <div className="text-center py-8 text-muted-foreground space-y-3">
      <div className="h-14 w-14 mx-auto rounded-full bg-primary/10 flex items-center justify-center">
        <Bell className="h-7 w-7 text-primary/60" />
      </div>
      <div>
        <p className="text-base font-medium text-foreground mb-1">All caught up! 🎉</p>
        <p className="text-sm">
          Check in a burger or follow friends to start earning badges and notifications.
        </p>
      </div>
    </div>
  );
}
